<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>米单管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               :rules="searchRules"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="米单配置名称"
                        prop="name">
            <el-input placeholder="请输入米单配置名称" clearable
                      v-model="search.name"></el-input>
          </el-form-item>
          <el-form-item label="当前状态"
                        prop="name">
            <el-select v-model="search.status"
                      class="width-max"
                      clearable
                      placeholder="请选择状态">
              <el-option
                v-for="(label, value) in options.status"
                :key="value"
                :label="label"
                :value="Number(value)">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <router-link :to="'/midan/create'">
          <el-button type="primary"
                     icon="sj-icon-add"
                     size="small">添加
          </el-button>
        </router-link>
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="ID"
                         width="90px"></el-table-column>
        <el-table-column prop="name"
                         label="米单配置名称"
                         width="120px"></el-table-column>
        <el-table-column prop="title"
                         label="虚拟任务标题"
                         width="120px"></el-table-column>
        <el-table-column prop="projectName"
                         label="虚拟任务项目"
                         minWidth="220px">
          <!-- <template slot-scope="scope">
            <span v-if="scope.row.projectid">{{scope.row.project_name}}/{{scope.row.project_number}}</span>
          </template> -->
        </el-table-column>
        <el-table-column prop="batchDetail"
                         label="虚拟任务批次"
                         minWidth="220px"
        >
          <!-- <template slot-scope="scope">
            <span v-if="scope.row.projectid">{{scope.row.batch_name}}/{{scope.row.batch_id}}</span>
          </template> -->
        </el-table-column>
        <el-table-column prop="status"
                         label="状态"
                         width="120px">
          <template slot-scope="scope">
            <span>{{options.status[scope.row.status]}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="op_name"
                         label="创建人"
                         width="190"></el-table-column>
        <el-table-column prop="created_at"
                         label="创建时间"
                         width="190"></el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="200">
          <template slot-scope="scope">
            <div class="button-gutter">
              <router-link :to="`/midan/detail/${scope.row.id}`">
                <el-button size="mini" type="success">查看</el-button>
              </router-link>
              <router-link v-if="[0, 1].includes(scope.row.status)" :to="`/midan/update/${scope.row.id}`">
                <el-button size="mini"
                           type="primary">编辑
                </el-button>
              </router-link>
              <el-button type="primary"
                         size="mini"
                         v-if="scope.row.status === 0"
                         @click="onStart(scope.row)">开启
              </el-button>
              <el-button type="danger"
                         size="mini"
                         v-if="scope.row.status === 1"
                         @click="onStop(scope.row.id)">关闭
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
    <MidanPreviewDialog
      :visible="showPreview"
      :data="previewData"
      @confirm="confirmSetting"
      @closeDialog="showPreview = false"></MidanPreviewDialog>
  </div>
</template>

<script>
import { searchRules } from '../midan.rules.js'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table-v3'

import MidanPreviewDialog from '../components/MidanPreviewDialog.vue'

export default {
  mixins: [table, dateTimePicker],
  components: {
    MidanPreviewDialog
  },
  data () {
    return {
      searchRules,
      search: {
        name: null,
        status: null,
      },
      searchFieldType: {
        status: Number
      },
      selectRow: null,
      showPreview: false,
      previewData: {},
    }
  },
  computed: Vuex.mapState({
    options: state => state.midan.options,
  }),
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getMidanTable', params)
    },
    confirmSetting () {
      let configId = this.selectRow.id
      this.$confirm('你确定要启动吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        request.common('startMidanData', {id: configId}).then((res) => {
          this.$message({
            type: 'success',
            message: '启动成功!',
          })
          this.selectRow.status = 1
          this.showPreview = false
          this.previewData = []
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消启动',
        })
        this.showPreview = false
        this.previewData = []
      })
    },
    onStart (scopeRow) {
      this.selectRow = scopeRow
      request.common('previewInfo', scopeRow).then(({data}) => {
        this.showPreview = true
        this.previewData = data
      })
    },
    onStop (id) {
      this.$confirm('你确定要关闭吗?', '提示', {
        type: 'warning',
      }).then(() => {
        request.common('stopMidanData', {id}).then((res) => {
          this.$message({
            type: 'success',
            message: '已关闭~!',
          })
          this.onRefresh()
        })
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/midan/pages/MidanTable.vue